// frontend/src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css'; 

// Import your custom components
import Home from './components/Home'; 
import PlaceholderPage from './components/PlaceholderPage'; 
import Header from './components/Header'; 
import Footer from './components/Footer'; 
import AboutUsPage from './components/AboutUsPage'; // <-- This is your custom page content
import ProductsPage from './components/ProductsPage'; 
import CompanyProfilePage from './components/company_profiile';
// import CompanyProfilePage from './components/company_profiile'; // Assuming we use AboutUsPage instead


function App() {
  return (
    <Router>
      <Header /> 
      <main>
        <Routes>
          {/* Main Website Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/industries" element={<PlaceholderPage title="Industries" />} />
          
          {/* 🎯 FIX 1: The 'About Us' link is likely still pointing to a placeholder. */}
          {/* Let's remove the extra/old '/about' route if it's not needed, or update it: */}
          <Route path="/about" element={<AboutUsPage />} /> 

          {/* 🎯 FIX 2: Map the Navbar's '/profile' path to your custom content component (AboutUsPage) */}
          <Route path="/profile" element={<CompanyProfilePage />} />
          
          <Route path="*" element={<h1>404 - Page Not Found</h1>} />
        </Routes>
      </main>
      <Footer /> 
    </Router>
  );
}

export default App;